import {
  CallDirection,
  CallStatus,
  ProcessingStatus,
  ZohoAssociatedModule,
} from "../../types/calls.types";

export const PAGE_SIZE = 50;

export const STATUS_OPTIONS: { value: CallStatus; label: string }[] = [
  { value: "METADATA_CAPTURED", label: "Metadata Captured" },
  { value: "AUDIO_LINKED", label: "Audio Linked" },
  { value: "AUDIO_LINKED_PROVISIONAL", label: "Audio Linked (Provisional)" },
];

export const DIRECTION_OPTIONS: { value: CallDirection; label: string }[] = [
  { value: "inbound", label: "Inbound" },
  { value: "outbound", label: "Outbound" },
  { value: "internal", label: "Internal" },
];

// Status column's A / T / S badges: green = done, amber = waiting,
// red = failed, grey = not started yet.
export const STATUS_BADGE_CLASS: Record<CallStatus, string> = {
  METADATA_CAPTURED: "bg-warning text-dark",
  AUDIO_LINKED: "bg-success",
  AUDIO_LINKED_PROVISIONAL: "bg-success",
};

export const STATUS_LABEL: Record<CallStatus, string> = {
  METADATA_CAPTURED: "Waiting for audio",
  AUDIO_LINKED: "Audio linked",
  AUDIO_LINKED_PROVISIONAL: "Audio linked (provisional)",
};

export const PROCESSING_BADGE_CLASS: Record<ProcessingStatus, string> = {
  COMPLETE: "bg-success",
  PENDING: "bg-warning text-dark",
  FAILED: "bg-danger",
};
export const PROCESSING_NOT_STARTED_BADGE_CLASS = "bg-light text-muted border";

export const PROCESSING_LABEL: Record<ProcessingStatus, string> = {
  COMPLETE: "Complete",
  PENDING: "Pending",
  FAILED: "Failed",
};
export const PROCESSING_NOT_STARTED_LABEL = "Not started";

export const DIRECTION_BADGE_CLASS: Record<CallDirection, string> = {
  inbound: "bg-info text-dark",
  outbound: "bg-secondary",
  internal: "bg-dark",
};

export const ZOHO_CRM_RECORD_URL = (module: ZohoAssociatedModule, id: string) =>
  `https://crm.zoho.eu/crm/org20103348189/tab/${module}/${id}`;

// Accounts are "Customers" in the CRM UI
export const ZOHO_MODULE_LABEL: Record<ZohoAssociatedModule, string> = {
  Accounts: "Customer",
  Contacts: "Contact",
  Leads: "Lead",
};

export const ZOHO_MODULE_BADGE_CLASS: Record<ZohoAssociatedModule, string> = {
  Accounts: "bg-primary",
  Contacts: "bg-info text-dark",
  Leads: "bg-warning text-dark",
};

// Transcript segment background per speaker (same palette as the old
// Transcription page); anything unexpected falls back to grey.
export const TRANSCRIPT_SPEAKER_COLOUR: Record<string, string> = {
  Agent: "#d4e6f1",
  Customer: "#d5f5e3",
};
export const TRANSCRIPT_SPEAKER_FALLBACK_COLOUR = "#f0f0f0";
